<app-main-outlet *ngIf="definitions"></app-main-outlet>
<suvo-bi-tour-outlet></suvo-bi-tour-outlet>